<script setup lang="ts">
import GaiaText from './GaiaText.vue';
import { gaiaFonts, gaiaFontSize, gaiaNeutral } from '../themes/tokens';

const props = defineProps({
  /** Uppercase label above the box, e.g. "Query preview". Omit for a bare box. */
  label: {
    type: String,
    default: undefined,
  },
});

const border = gaiaNeutral.borderSubtle;
const surface = gaiaNeutral.surfaceSoft;
const text = gaiaNeutral.text;
const monoFont = gaiaFonts.mono;
// The readout is mono and wraps, which GaiaText's props don't cover, so its
// step comes through v-bind alongside the family.
const codeSize = gaiaFontSize.micro;
</script>

<template>
  <!-- Read-only monospace readout — the filter builder's query preview. Not an
       input: the value is generated, so it is rendered rather than editable.
       Mono here is meaningful, not decorative: it makes the parentheses and
       operators of a boolean expression scannable. -->
  <div class="gaia-code-box">
    <gaia-text v-if="props.label" variant="label" size="micro" tone="faint">
      {{ props.label }}
    </gaia-text>
    <div class="code"><slot /></div>
  </div>
</template>

<style scoped>
.gaia-code-box {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 11px 13px;
  border: 1px solid v-bind(border);
  border-radius: 10px;
  background: v-bind(surface);
}

/* Mono at 11.5px with the roomier line-height a wrapped expression needs —
   both are box metrics for this readout, not steps on the text scale. */
.code {
  font-family: v-bind(monoFont);
  font-size: v-bind(codeSize);
  line-height: 1.6;
  color: v-bind(text);
  overflow-wrap: anywhere;
}
</style>
